import { RealTimeEventTypes } from '@/enums/RealTimeEventTypes'
import type { IConnectorManuallyFaultedMessage } from '@/models/Connectors/IConnectorManuallyFaultedMessage'
import type { IConnectorStatusChangedMessage } from '@/models/Connectors/IConnectorStatusChangedMessage'
import { type EventHandler, type IRealtimeEventService, RealTimeEventService } from '@/service/RealTimeEvents/RealTimeEventService'
import { injectable } from 'inversify'

export interface IConnectorRealTimeEventService extends IRealtimeEventService {}

@injectable()
export class ConnectorRealTimeEventService extends RealTimeEventService implements IConnectorRealTimeEventService {
  constructor(hub: string = 'connector') {
    super(hub)
  }

  buildConnection(): void {
    super.buildConnection()
    this.connection.on('ConnectorStatusChangedEventAsync', this.onConnectorStatusChangedEvent.bind(this))
    this.connection.on('ConnectorManuallyFaultedEventAsync', this.onConnectorManuallyFaultedEvent.bind(this))
  }

  async onConnectorStatusChangedEvent(connectorStatusChangedMessage: IConnectorStatusChangedMessage): Promise<void> {
    this.eventHandlers
      .filter(eh => eh.eventType === RealTimeEventTypes.ConnectorStatusChangedEvent)
      .forEach(async (eventHandler: EventHandler<IConnectorStatusChangedMessage>) => {
        await eventHandler.handle(connectorStatusChangedMessage)
      })
  }

  async onConnectorManuallyFaultedEvent(connectorManuallyFaultedMessage: IConnectorManuallyFaultedMessage): Promise<void> {
    this.eventHandlers
      .filter(eh => eh.eventType === RealTimeEventTypes.ConnectorManuallyFaultedEvent)
      .forEach(async (eventHandler: EventHandler<IConnectorManuallyFaultedMessage>) => {
        await eventHandler.handle(connectorManuallyFaultedMessage)
      })
  }
}
